module.exports = __webpack_public_path__ + "img/img-magic-4-b-01-img-01.fcd279eb.png";